import React from 'react'
import clsx from 'clsx'
import Imgix, { Background } from 'react-imgix'
import { ResponsiveImageProps } from './ResponsiveImageProps'
import useStyles from './ResponsiveImage.styles'

const FullWidthImageOverlayComponent = React.forwardRef<
  HTMLDivElement,
  ResponsiveImageProps
>(
  (
    { src, mobileSrc, className, overlayClassName, imageClassName, children },
    ref
  ) => {
    const mobileImageSrc = mobileSrc ?? src
    const classes = useStyles()

    return (
      <div className={clsx(classes.responsiveImage, className)} ref={ref}>
        <Background
          src={src}
          className={clsx(classes.blurredBackground, classes.desktop)}
        />

        <Imgix
          sizes="100vw"
          src={mobileImageSrc}
          className={clsx(classes.mobile, imageClassName)}
        />

        <Imgix
          sizes="1920px"
          src={src}
          className={clsx(classes.desktop, imageClassName)}
        />

        <div className={clsx(classes.overlay, overlayClassName)}>
          {children}
        </div>
      </div>
    )
  }
)

export default FullWidthImageOverlayComponent
